import { render, staticRenderFns } from "./StandardDialog.vue?vue&type=template&id=40d6abdc&"
import script from "./StandardDialog.vue?vue&type=script&lang=js&"
export * from "./StandardDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports